import contentsCustomTypesEnum from "@project/enums/contentsCustomTypes.enum";
import ContentsTypes from "@shared/enums/contentsTypes";
export const DescriptionServicesItem = {
    label: "Service avec description",
    key: "items",
    type: contentsCustomTypesEnum.DESCRIPTION_SERVICES_ITEM,
    children: [
        {
            label: "Icône",
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
        },
        {
            label: "Couleur de bordure",
            key: "borderColor",
            type: ContentsTypes.COLOR,
            value: "#AAAAB6",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Composant",
            key: "component",
            type: ContentsTypes.SELECT,
            options: [
                { label: "par défaut", value: "p" },
                { label: "h1", value: "h1" },
                { label: "h2", value: "h2" },
                { label: "h3", value: "h3" },
                { label: "h4", value: "h4" },
                { label: "h5", value: "h5" },
                { label: "h6", value: "h6" },
            ],
            value: "p",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
    ],
};
export const DescriptionServices = {
    label: "Carte description de service",
    type: contentsCustomTypesEnum.DESCRIPTION_SERVICE_CARD,
    icon: "money-check",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Taille",
            key: "size",
            type: ContentsTypes.SELECT,
            options: [
                { label: "petit", value: "S" },
                { label: "moyen", value: "M" },
                { label: "grand", value: "L" },
            ],
            value: "M",
        },
        {
            label: "Mode sombre",
            key: "isDark",
            type: ContentsTypes.CHECKBOX,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Composant",
            key: "component",
            type: ContentsTypes.SELECT,
            options: [
                { label: "par défaut", value: "p" },
                { label: "h1", value: "h1" },
                { label: "h2", value: "h2" },
                { label: "h3", value: "h3" },
                { label: "h4", value: "h4" },
                { label: "h5", value: "h5" },
                { label: "h6", value: "h6" },
            ],
            value: "p",
        },
        {
            label: "Espacement (px)",
            key: "spacing",
            type: ContentsTypes.SLIDER,
            min: "0",
            max: "50",
            step: "2",
            value: "8",
        },
        {
            label: "Espacement (px) pour mobile",
            key: "mobileSpacing",
            type: ContentsTypes.SLIDER,
            min: "0",
            max: "32",
            step: "2",
            value: "24",
        },
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [DescriptionServicesItem],
                    value: contentsCustomTypesEnum.DESCRIPTION_SERVICES_ITEM,
                },
            ],
        },
    ],
};
